import { UseRecordsOptions } from "../../api/useRecords";
import { RecordContextType } from "../../components/record/Record";

export const staffRemunerationOptions = {
    fieldsToRemove: {
        fieldNamesToRemove: ["id", "content"],
        fieldTypesToRemove: ["alias"],
    },
    groupsOptions: {
        fieldsWithExtraOptions: [
            {
                field: "contract",
                fileFolder: "a80a2485-67b2-4c60-98bb-4b5a61d8bd39",
                instanceToUse: "finance",
            },
        ],
    },
    createRelatedParams: (params: RecordContextType | undefined) => createStaffRemunerationParams(params),
} as unknown as UseRecordsOptions;



const createStaffRemunerationParams = async (recordContext: RecordContextType | undefined) => {
    if (!recordContext?.item) return;

    if (recordContext.entity === "staff_agreements") return `[operations_staff_agreement_id]=${recordContext.item.id}`;
};
